<script setup>
import {onMounted, reactive, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import { useRouter } from 'vue-router';

const compName = 'ClientSelectComponent';

const emit = defineEmits(['clientSelected']);

const data = reactive({
  loading: true,
  clientId: null,
  clients: []
});

const form = ref(null);
const router = useRouter();

const getAllClients = async () => {
  data.loading = true;

  await ApiWrapper.get('claims', 'all-clients')
      .then((response) => {
        data.clients = [
          {
            title: 'All',
            key: null
          },
          ...response.clients.map((client) => {
            return {
              title: client.name,
              key: client.id
            }
          })
        ];
      })
      .catch((e)=>{
        data.clients = [{
          title: 'All',
          key: null
        }];
      })
      .finally(() => {
        data.loading = false;
      })
}

const getData = async() => {
  await getAllClients();
}

const changeClient = () => {
  emit('clientSelected', data.clientId);
}

onMounted(()=>{
  getData();
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Filter by Client</v-toolbar-title>
        <v-progress-linear :active="data.loading" :indeterminate="data.loading" absolute bottom color="primary">
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>

      <v-row class="px-5">
        <v-col cols="12">
          <v-select
              :items="data.clients"
              v-model="data.clientId"
              label="Client"
              item-title="title"
              item-value="key"
              clearable
          ></v-select>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn color="primary" variant="elevated" @click="changeClient">Filter</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped>
v-container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>